import { inject } from 'vue';
export const ZiggySymbol = Symbol();
export const ZiggyService = {
    install: (app) => {
        const route = window.route;
        app.mixin({ methods: { route } }).provide(ZiggySymbol, route);
        app.config.globalProperties.$ziggyRoute = route;
    },
};
export function useRoute() {
    const ziggy = inject(ZiggySymbol);
    if (!ziggy) {
        throw new Error(`Could not resolve ${ZiggySymbol.description}`);
    }
    return ziggy;
}
